/*
*   网站首页入口
*/
import './css/app.css';

//////////引入组件//////////
import NavMenu from './components/navs/NavMenu';
import Slide from './components/homes/Slide';
import HH1 from './components/homes/HH1';
import Premium from './components/homes/Premium';
import HH2 from './components/homes/HH2';
import Project from './components/homes/Project';
import Number from './components/homes/Number';
import Aboutus from './components/homes/Aboutus';
import HH3 from './components/homes/HH3';
import HH4 from './components/homes/HH4';
import Focus from './components/homes/Focus';
import Footer from './components/footers/Footer';
//////////引入组件//////////
const Home = (props) => {
    return (
        <>
            <div className='header'><NavMenu m={props.m}/></div>
            <div className='home'>
                <div className='slide'><Slide /></div>
                <div className='home-title' style={{ backgroundColor: '#F7F7F7' }}><HH1 /></div>
                <div className='premium'><Premium /></div>
                <div className='home-title'><HH2 /></div>
                <div className='project'><Project /></div>
                <div className='number'><Number /></div>
                <div className='aboutus'>
                    <HH3 />
                    <Aboutus />
                </div>
                <div className='home-title'><HH4 /></div>
                <div className='news'></div>
                <div className='focus'><Focus /></div>
            </div>
            <div className='footer'><Footer /></div>
        </>
    );
};

export default Home;